export const exterior_view01ImageOptions = {
  angle: 'exterior_view01',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SolarPanels: 1,
    DavidsRib: 1,
    RemovableGangway: 1,
    Wheel: 1,
    SprayHood: 1,
    BoomCover: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'Wheel'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'SolarPanels',
      dependency: null
    },
    {
      option: 'DavidsRib',
      dependency: null
    },
    {
      option: 'RemovableGangway',
      dependency: null
    },
    {
      option: 'Wheel',
      dependency: null
    },
    {
      option: 'SprayHood',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/exterior_view01.js